import React from 'react';
import { albumsOfTheYear } from '../data/albumsOfTheYear';

const AlbumsOfTheYear = () => {
  return (
    <section id="albums-of-the-year">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <h2>Albums of the Year</h2>
            <hr className="star-primary" />
            <p style={{ maxWidth: '750px', margin: '20px auto 40px auto', fontSize: '18px', lineHeight: '1.6', color: '#555' }}>
              These are my top albums for each year. It isn't easy to pick but these are the ones that at the end of the year I had played the most and had the most impact for me. I stuck to albums released that year, and I haven't retrospectively changed any if I subsequently discovered an album that I missed that year.
            </p>
          </div>
        </div>

        {/* Albums List by Year */}
        {albumsOfTheYear.map(item => (
          <div key={item.year} className="row divider" style={{ paddingTop: '30px', paddingBottom: '30px' }}>
            <div className="col-md-3 col-sm-12">
              <div style={{ marginBottom: '20px' }}>
                <h3 style={{ marginTop: 0, color: '#2c3e50', fontWeight: 'bold' }}>
                  <i className="fa fa-calendar-o" style={{ marginRight: '8px', color: '#B22816' }}></i>
                  {item.year}
                </h3>
              </div>
            </div>

            <div className="col-md-9 col-sm-12">
              <div className="row">
                {/* WINNER */}
                {item.winner && (
                  <div className="col-sm-6 col-xs-12" style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        background: '#ffffff',
                        border: '2px solid #B22816',
                        borderRadius: '8px',
                        padding: '16px',
                        boxShadow: '0 2px 8px rgba(178, 40, 22, 0.15)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        height: '100%',
                        position: 'relative'
                      }}
                    >
                      {/* Winner Badge */}
                      <div
                        style={{
                          position: 'absolute',
                          top: '-12px',
                          left: '14px',
                          background: '#B22816',
                          color: '#ffffff',
                          padding: '2px 10px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                          letterSpacing: '0.8px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                        }}
                      >
                        <i className="fa fa-trophy" style={{ marginRight: '4px', color: '#f1c40f' }}></i>
                        Winner
                      </div>

                      {/* Thumbnail */}
                      {item.winner.artwork ? (
                        <img
                          src={item.winner.artwork}
                          alt={`${item.winner.artist} - ${item.winner.title}`}
                          style={{
                            width: '90px',
                            height: '90px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.15)',
                            flexShrink: 0
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: '90px',
                            height: '90px',
                            borderRadius: '6px',
                            background: '#eee',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}
                        >
                          <i className="fa fa-music" style={{ fontSize: '28px', color: '#B22816' }}></i>
                        </div>
                      )}

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: '17px',
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                          title={item.winner.artist}
                        >
                          {item.winner.artist}
                        </div>
                        <div
                          style={{
                            fontSize: '14px',
                            color: '#555',
                            fontStyle: 'italic',
                            marginTop: '4px',
                            wordBreak: 'break-word'
                          }}
                        >
                          {item.winner.title}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* RUNNER UP */}
                {item.runnerUp && (
                  <div className="col-sm-6 col-xs-12" style={{ marginBottom: '20px' }}>
                    <div
                      style={{
                        background: '#fcfcfc',
                        border: '1px solid #ddd',
                        borderLeft: '4px solid #7f8c8d',
                        borderRadius: '8px',
                        padding: '16px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        height: '100%',
                        position: 'relative'
                      }}
                    >
                      {/* Runner Up Badge */}
                      <div
                        style={{
                          position: 'absolute',
                          top: '-12px',
                          left: '14px',
                          background: '#7f8c8d',
                          color: '#ffffff',
                          padding: '2px 10px',
                          borderRadius: '12px',
                          fontSize: '11px',
                          fontWeight: 'bold',
                          textTransform: 'uppercase',
                          letterSpacing: '0.8px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.15)'
                        }}
                      >
                        <i className="fa fa-star" style={{ marginRight: '4px', color: '#ecf0f1' }}></i>
                        Runner Up
                      </div>

                      {/* Thumbnail */}
                      {item.runnerUp.artwork ? (
                        <img
                          src={item.runnerUp.artwork}
                          alt={`${item.runnerUp.artist} - ${item.runnerUp.title}`}
                          style={{
                            width: '90px',
                            height: '90px',
                            objectFit: 'cover',
                            borderRadius: '6px',
                            boxShadow: '0 2px 5px rgba(0,0,0,0.12)',
                            flexShrink: 0
                          }}
                        />
                      ) : (
                        <div
                          style={{
                            width: '90px',
                            height: '90px',
                            borderRadius: '6px',
                            background: '#eee',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0
                          }}
                        >
                          <i className="fa fa-music" style={{ fontSize: '28px', color: '#7f8c8d' }}></i>
                        </div>
                      )}

                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontSize: '17px',
                            fontWeight: 'bold',
                            color: '#2c3e50',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                          }}
                          title={item.runnerUp.artist}
                        >
                          {item.runnerUp.artist}
                        </div>
                        <div
                          style={{
                            fontSize: '14px',
                            color: '#555',
                            fontStyle: 'italic',
                            marginTop: '4px',
                            wordBreak: 'break-word'
                          }}
                        >
                          {item.runnerUp.title}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default AlbumsOfTheYear;
